/* eslint-disable */
import React, { useEffect, useState } from "react";
import "./App.css";

import "@boldreports/javascript-reporting-controls/Scripts/bold.report-viewer.min";
import "@boldreports/javascript-reporting-controls/Content/material/bold.reports.all.min.css";
//Data-Visualization
import "@boldreports/javascript-reporting-controls/Scripts/data-visualization/ej.bulletgraph.min";
import "@boldreports/javascript-reporting-controls/Scripts/data-visualization/ej.chart.min";
//Reports react base
import "@boldreports/react-reporting-components/Scripts/bold.reports.react.min";
import { fetchReportData } from "./services/ReportService";
import { loadConfig } from "./utils/configLoader";
import { Config } from "./models/Config";
import { ReportType } from "./models/ReportType";
import { getReportMapping } from "./utils/getReportMapping";

declare let BoldReportViewerComponent: any;

var viewerStyle = {
  height: "100vh",
  width: "100%",
};

function App() {
  const [loading, setLoading] = useState(true);
  const [authToken, setAuthToken] = useState("");
  const [report, setReport] = useState<ReportType>(ReportType.IncomeByCategory);
  const [config, setConfig] = useState<Config | null>(null);
  const [filterData, setFilterData] = useState<Record<string, any>>({});
  const [reportData, setReportData] = useState([
    {
      value: [],
      name: "tuos-api-data",
    },
  ]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === "SET_FILTERS" && event.data.filters) {
        setFilterData(event.data.filters);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  useEffect(() => {
    const init = async () => {
      const configData = await loadConfig();
      setConfig(configData);
    };
    init();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const report = params.get("report") as ReportType;
    if (token) {
      setAuthToken(token);
    }
    if (report) {
      setReport(report);
    }
  }, []);

  useEffect(() => {
    const loadData = async () => {
      if (!authToken || !config) return;

      const params = new URLSearchParams(window.location.search);

      const urlFilters: Record<string, any> = {};
      params.forEach((value, key) => {
        if (!["token", "report", "filter"].includes(key)) {
          urlFilters[key] = value;
        }
      });

      const mergedFilterData = { ...urlFilters, ...filterData };

      const reportDataUrl = `${config.reportDataBaseUrl}/api/reports/${report}`;
      const reportMapping = getReportMapping(report);

      const tempData = await fetchReportData(
        `${reportDataUrl}`,
        authToken,
        reportMapping,
        mergedFilterData
      );

      setReportData([
        {
          value: tempData,
          name: "tuos-api-data",
        },
      ]);

      setLoading(false);
    };
    loadData();
  }, [authToken, config, filterData]);

  if (loading || !config) {
    return <div>Loading...</div>;
  }

  const exportItem = (args: any) => {
    const params = new URLSearchParams(window.location.search);
    const today = new Date().toISOString().split("T")[0];
    const companyID = params.get("companyID") ?? "";
    const reportName = report
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    args.fileName = `${companyID} ${reportName} ${today}`;
  };

  return (
    <>
      <div className="lg:hidden p-4 text-center text-gray-700">
        Reports are not available on smaller screens.
      </div>

      <div className="hidden lg:block" style={viewerStyle}>
        <BoldReportViewerComponent
          id="reportviewer-container"
          reportServiceUrl={config.reportServiceUrl}
          reportPath={report + ".rdlc"}
          processingMode={"Local"}
          dataSources={reportData}
          exportItemClick={exportItem}
        ></BoldReportViewerComponent>
      </div>
    </>
  );
}

export default App;
